function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
export const getColumnWidths = _ref => {
  let {
    totalWidth,
    tableHeaders
  } = _ref;
  // headerIndex => headerWidth in pixels -- { 0: 100, 1: 200} etc.
  // empty object otherwise
  const columnFixedWidths = tableHeaders.map((header, index) => {
    if (header.width && typeof header.width === 'number') {
      return [index, header.width];
    } else if (header.width && typeof header.width === 'string') {
      // deprecated - because we cannot account for all possible strings - e.g. 1rem 1px 1vw 1% 1em etc.
      // assume string is pixels - e.g. '100px'
      return [index, parseInt(header.width)];
    }
    // some can be undefined
  }).reduce((accumulator, current) => {
    if (current) {
      accumulator[current[0]] = current[1];
    }
    return accumulator;
  }, {});

  // Calculate the total fixed width
  const totalFixedWidth = Object.values(columnFixedWidths).reduce((sum, width) => sum + width, 0);

  // Calculate width for dynamic columns
  const dynamicColumnsCount = tableHeaders.length - Object.keys(columnFixedWidths).length;
  const dynamicColumnWidth = (totalWidth - totalFixedWidth) / dynamicColumnsCount;
  const allColumnWidths = _objectSpread(_objectSpread({}, columnFixedWidths), {}, {
    dynamicColumnWidth: dynamicColumnWidth
  });
  return allColumnWidths;
};